<template>
  <div>
    <heard />
    <!-- <div class="title">量表制作页</div> -->
    <div class="tableWrapper">
      <el-button type="primary" size="small" class="margin-b-20" @click="add"
        >增加题目</el-button
      >
      <div class="customTable" v-if="tableData.length" >
        <!-- <div class="tableHeard"></div> -->
        <div class="tableBody">
          <div class="tableRow" v-for="(item, index) in tableData" :key="index">
            <div class="tableCell tableCell1">
              <span>{{ renderCategory(item.mqCategoryEnum) }}</span>
            </div>
            <div class="tableCell tableCell2">
              <div v-html="item.mqContent"></div>
            </div>
            <div class="tableCell tableCell3">
              <el-input-number
                :max="item.mqScore * 1"
                :min="0"
                size="small"
                v-model="item.mqScore"
                :step="1"
              ></el-input-number>
            </div>
            <div class="tableCell tableCell4">
              {{ item.mqTypeEnum == 1 ? "文字题" : "录音题" }}
            </div>
            <div class="tableCell tableCell5">
              <el-button style="height:32px" type="primary" size="mini" @click="up(index)"
                >上升</el-button
              >
              <el-button style="height:32px" type="primary" size="mini" @click="down(index)"
                >下降</el-button
              >
              <el-button style="height:32px" type="danger" size="mini" @click="remove(item.id)"
                >删除</el-button
              >
              <el-button style="height:32px" type="info" size="mini" @click="edit(item)"
                >编辑</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <el-empty description="请添加题目"></el-empty>
      </div>
      <div class="foot" v-if="tableData.length">
        <el-button size="small" class="width-100" @click="fullFlag = true" >预览</el-button>
        <el-button size="small" v-if="$route.query.cmStatus !='已发布'" class="width-100" type="primary" @click="publishMmse">发布</el-button>
        <el-button size="small" class="width-100" type="success" @click="back">存为草稿</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="showDialogFlag" @close="closeDialog">
      <el-form :model="form">
        <!-- <el-form-item label="考察点" label-width="80px">
          <el-input
            v-model="form.cmTitle"
            class="width-300"
            size="medium"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="考察点" label-width="80px">
          <el-select
            v-model="form.mqCategoryEnum"
            placeholder="请选择"
            class="width-300"
            size="medium"
          >
            <el-option
              v-for="item in mqCategoryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分值" label-width="80px">
          <el-input-number
            class="width-300"
            size="medium"
            v-model="form.mqScore"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="类型" label-width="80px">
          <el-select
            v-model="form.mqTypeEnum"
            placeholder="请选择"
            class="width-300"
            size="medium"
          >
            <el-option
              v-for="item in mqTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题描述" label-width="80px">
          <div id="div1"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialogFlag = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" size="small" @click="saveItem"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      v-if="fullFlag"
      :close-on-press-escape='true'
      :isQuery="true"
      :visible.sync="fullFlag"
      :fullscreen="true"
      :testPageTitle="$route.query.testPageTitle"
      :before-close="handleCloseFull">
     <testPage :tableData="tableData" />
    </el-dialog>
  </div>
</template>

<script>
import E from "wangeditor";
import heard from "../components/heard.vue";
import testPage from './testPage.vue'
import {
  addCustomItem,
  getCustomRecord,
  getCustomUpdown,
  reomveCustomRecord,
  updateCustomRecord,
  publishCustomRecord,
  uploadFileRich
} from "@/utils/custom";
const resourceUrl = 'https://language.phenxie.com/oss/'
export default {
  data() {
    return {
      tableData: [],
      editor: null,
      showDialogFlag: false,
      form: {
        mqCategory: "",
        mqCategoryEnum: "",
        mqScore: "",
        mqTypeEnum: "",
        mqType: "",
        mqContent: "",
        mqSequNo: 0,
        mmseId: "",
      },
      mqCategoryList: [
        {
          label: "定向力",
          value: "1",
        },
        {
          label: "记忆力",
          value: "2",
        },
        {
          label: "注意力和计算力",
          value: "3",
        },
        {
          label: "回忆能力",
          value: "4",
        },
        {
          label: "语言能力",
          value: "5",
        },
        {
          label: "其他",
          value: "6",
        },
      ],
      mqTypeList: [
        {
          label: "文字题",
          value: "1",
        },
        {
          label: "录音题",
          value: "2",
        },
      ],
      currentIndex: -1,
      isEdit: false,
      editParams: {},
      fullFlag:false
    };
  },
  computed: {
    mmseId() {
      return this.$route.query.id;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleCloseFull(){
      this.fullFlag = false
    },
    publishMmse(){
      const params = [this.mmseId];
      publishCustomRecord(params).then(res=>{
        this.$message.success('发布成功')
        this.$router.go(-1)
      })
    },
    back(){
      this.$router.go(-1)
    },
    closeDialog() {
      this.editor.destroy();
    },
    edit(item) {
      this.isEdit = true;
      const params = {
        mqCategory: item.mqCategory,
        mqCategoryEnum: item.mqCategoryEnum,
        mqTypeEnum: item.mqTypeEnum,
        mqType: item.mqType,
        mqContent: item.mqContent,
        mqSequNo: item.mqSequNo,
        mqScore: item.mqScore,
        id: item.id,
        mmseId: this.mmseId,
      };
      this.editParams = params;
      this.form.mqCategoryEnum = `${item.mqCategoryEnum}`;
      this.form.mqScore = item.mqScore;
      this.form.mqTypeEnum = `${item.mqTypeEnum}`;
      this.showDialogFlag = true;
      this.initWangEdit(item);
    },
    remove(id) {
      this.$confirm("是否确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reomveCustomRecord(id).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    up(index) {
      if (index == 0) {
        return;
      }
      let listData = [];
      this.tableData.splice(index - 1, 0, this.tableData[index]);
      this.tableData.splice(index + 1, 1);
      this.tableData.forEach((item, index1) => {
        listData.push({
          mqSequNo: index1 + 1,
          id: item.id,
        });
      });
      getCustomUpdown(listData).then((res) => {
        this.getList();
      });
    },
    down(index) {
      if (this.tableData.length - 1 == index) {
        return;
      }
      let listData = [];
      this.tableData.splice(index + 2, 0, this.tableData[index]);
      this.tableData.splice(index, 1);
      this.tableData.forEach((item, index1) => {
        listData.push({
          mqSequNo: index1 + 1,
          id: item.id,
        });
      });
      getCustomUpdown(listData).then(() => {
        this.getList();
      });
    },
    renderCategory(mqCategoryEnum) {
      return this.mqCategoryList.filter(
        (item) => item.value == mqCategoryEnum
      )[0].label;
    },
    saveItem() {
      this.form.mqContent = this.editor.txt.html();
      this.form.mqSequNo = this.isEdit ?  this.editParams.mqSequNo : this.tableData.length + 1;
      this.form.mmseId = this.mmseId;
      this.form.mqType = this.mqTypeList.filter(
        (item) => item.value == this.form.mqTypeEnum
      )[0].label;
      this.form.mqCategory = this.mqCategoryList.filter(
        (item) => item.value == this.form.mqCategoryEnum
      )[0].label;
      if (this.isEdit) {
        this.form.id = this.editParams.id;
      } else {
        delete this.form.id;
      }
      (this.isEdit ? updateCustomRecord : addCustomItem)(this.form).then(() => {
        this.getList();
        this.editor.destroy();
        this.showDialogFlag = false;
        this.isEdit = false;
        this.form.mqCategoryEnum = "";
        this.form.mqScore = "";
        this.form.mqTypeEnum = "";
        this.form.mqContent = "";
      });
    },
    getList() {
      const params = {
        mmseId: this.mmseId,
      };
      getCustomRecord(params).then((res) => {
        this.tableData = res.rows;
      });
    },
    add() {
      this.currentIndex = -1;
      this.showDialogFlag = true;
      this.initWangEdit();
    },
    initWangEdit(obj) {
      this.$nextTick(() => {
        this.editor = new E("#div1");
        (this.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
          let fd = new FormData();
          fd.append("richPic", resultFiles[0]);
          uploadFileRich(fd).then(res=>{
            insertImgFn(resourceUrl + res.data);
          })
        }),
          this.editor.create();
        if (obj && obj.mqContent) {
          this.editor.txt.html(obj.mqContent);
        }
      });
    },
  },
  components: {
    heard,
    testPage
  },
};
</script>

<style lang="less" scoped>
.title {
  font-size: 20px;
  color: #000000;
  font-weight: bold;
  margin-top: 20px;
  text-align: left;
  margin-left: 30px;
}
.tableWrapper {
  margin-top: 30px;
  padding: 0 20px;
}
.margin-b-20 {
  margin-bottom: 20px;
}
.width-300 {
  width: 300px;
}
.foot{
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  .width-100{
    width: 100px;
  }
}
.customTable {
  border: 1px solid #000000;
  border-bottom: 0;
  .tableHeard {
    height: 169px;
    border-bottom: 1px solid #000000;
  }
  .tableRow {
    border-bottom: 1px solid #000000;
    display: flex;
    .tableCell {
      padding: 25px 0;
      border-right: 1px solid #000000;
    }
    .tableCell1 {
      width: 10%;
      span {
        margin-left: 20px;
      }
      // padding-left: 20px;
    }
    .tableCell2 {
      flex: 1;
      width: 54%;
      display: flex;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      //    padding-left: 20px;
    }
    .tableCell3 {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 10%;
      // padding-left: 20px;
    }
    .tableCell4 {
      width: 10%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tableCell5 {
      // padding-left: 20px;
      width: 16%;
      border-right: 0 !important;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }
  }
}
// table{
//     border-collapse: collapse;
//     width: 100%;
//     td{
//         border: 1px solid #000000;
//         margin: 0;
//     }
// }
</style>
